
//Libraries
import router from "@/core/router";
import { defineComponent, ref } from "vue";

//Store
import { useStore } from "../../../store/index";

//Types
import { ModalMutationOptions } from "../../types/enum/store-enum";

//Components
import LoadingProcess from "../LoadingProcess.vue";

export default defineComponent({
  name: "GameCreator",
  components: {
    LoadingProcess,
  },
  setup() {
    //Data
    const store = useStore();

    const isLoading = ref<boolean>(false);

    const createProcessStatus = ref<number>(0);

    const createProcessTitle = ref<string>("");

    //Methods
    const create = () => {
      isLoading.value = true;
      createProcessTitle.value = "Creando";

      setTimeout(() => {
        createProcessStatus.value = 60;

        setTimeout(() => {
          createProcessStatus.value = 100;
          createProcessTitle.value = "Redirigiendo";

          setTimeout(() => {
            router.push("/game");
            closeModal();
          }, 1200);
        }, 1200);
      }, 200);
    };

    const closeModal = () => {
      store.commit(ModalMutationOptions.closeModal);
    };

    return {
      //Data
      isLoading,
      createProcessTitle,
      createProcessStatus,
      //Methods
      create,
      closeModal,
    };
  },
});
